<template>
  <div>
    <h2>
        Asistencia del mes..
    </h2>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>